import {Preferences} from '@capacitor/preferences';

export abstract class AbstractPreferencesManager {

    protected async setBoolValue(key: string, value: true | false): Promise<void> {
        await Preferences.set({
            key: key,
            value: JSON.stringify(value || false),
        });
    }

    protected async getBoolValue(key: string): Promise<boolean> {
        const {value} = await Preferences.get({key: key});
        return Boolean(JSON.parse(value || 'false'));
    }

    protected async setValue(key: string, value: string): Promise<void> {
        await Preferences.set({
            key: key,
            value: value,
        });
    }

    protected async getValue(key: string): Promise<string | null> {
        const {value} = await Preferences.get({key: key});
        return value;
    }

    protected async removeValue(key: string): Promise<void> {
        await Preferences.remove({key: key});
    }
}